import { Card } from "@/components/ui/card";
import { Box, TrendingDown, TrendingUp } from "lucide-react";

export function StockSummary({ data }: { data: any[] }) {
  const totalItems = data.reduce((acc, item) => acc + item.quantity, 0);
  const criticalItems = data.filter(
    (item) => item.quantity <= item.minimum_quantity
  ).length;

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="p-6 bg-[#0073B7] text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">Total em Estoque</p>
            <h3 className="text-2xl font-bold">{totalItems}</h3>
          </div>
          <Box className="w-8 h-8" />
        </div>
      </Card>

      <Card className="p-6 bg-[#E60026] text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">Itens em Nível Crítico</p>
            <h3 className="text-2xl font-bold">{criticalItems}</h3>
          </div>
          <TrendingDown className="w-8 h-8" />
        </div>
      </Card>

      <Card className="p-6 bg-[#004080] text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">Movimentações do Mês</p>
            <h3 className="text-2xl font-bold">--</h3>
          </div>
          <TrendingUp className="w-8 h-8" />
        </div>
      </Card>
    </div>
  );
}